var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e6-pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":_vm.pageSize,"layout":_vm.layout,"total":_vm.total},on:{"current-change":_vm.currentChange,"size-change":_vm.sizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }